import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8607e1da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ct-icon-close" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ct-icon-arrow-left" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ct-icon-arrow-right" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "show-dialog",
      onAfterEnter: _ctx.focusDialog
    }, {
      default: _withCtx(() => [
        (_ctx.dialogVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["dialog-overlay", { 'is-dark': _ctx.darkMode }]),
              tabindex: "0",
              ref: "dialogElement",
              onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
            }, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args))),
                class: "dialog-overlay__close-btn"
              }, _hoisted_2),
              _createElementVNode("div", {
                class: _normalizeClass(["dialog-body", _ctx.bodyClass])
              }, [
                (_ctx.hasNavButtons)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        class: "dialog-body__nav-btn is-left",
                        disabled: _ctx.navLeftBtnDisabled,
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('left-click')))
                      }, _hoisted_5, 8, _hoisted_3),
                      _createElementVNode("button", {
                        class: "dialog-body__nav-btn is-right",
                        type: "button",
                        disabled: _ctx.navRightBtnDisabled,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('right-click')))
                      }, _hoisted_8, 8, _hoisted_6)
                    ], 64))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ], 2)
            ], 34))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onAfterEnter"])
  ]))
}